import React from "react" 
import { useDetailScreenCtx } from "../DetailScreensRender"


export default function TrxDetailValue({ value, size="md", className="" }:{ value:any; size?:string; className?:string }){
  const { visualEffects }:any = useDetailScreenCtx()
  return (
    <span style={{
      fontSize: size === "lg" ? "1rem" : "0.875rem",
      fontWeight: "300",
      color: "#000000",
      lineHeight: "1.2rem",
      wordBreak: "normal",
      whiteSpace: "normal",
      textAlign: "right",
      // whiteSpace: "nowrap",
    }}>
      {value}
    </span>
  )
}